import { UnixTimestamp } from "@cervval.js/common/src/tools/timestamps.tools.definitions";
import { MinimalUserProfile, PhoneAppUser } from "./user.model";

/**
 * Nullify user authentication information :
 * remove password-related information or auth token if possible, otherwise set it to an empty / falsy value
 * @param user UserDTO object
 */
export function nullifyUserAuthInformation(user: MinimalUserProfile & Partial<PhoneAppUser>): void {
    user.notificationToken = undefined;
    user.password = undefined;
    user.passwordResetRequired = false;
    user.resetPasswordKey = "";
    user.resetPasswordKeyGenerationTime = 0 as unknown as UnixTimestamp;
}

/** Firstname Lastname */
export function formatUserName(user: MinimalUserProfile): string {
    return `${user.givenName} ${user.familyName.toUpperCase()}`;
}

/** Jean Dupont → JD */
export function formatInitials(user: MinimalUserProfile): string {
    return (user.givenName.slice(0, 1).toUpperCase() + user.familyName.slice(0, 1).toUpperCase()).toUpperCase();
}